import * as z from "zod";

export const deleteWorkOrderViewFolder = {
  name: "deleteWorkOrderViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
